import React from 'react';

const Home = ( props ) => (
  <></>
);

export default Home;
